import { ProductTier } from '@sparemin/api-sdk';
import React from 'react';
import { useDispatch } from 'react-redux';
import useConnectedModal from 'containers/ConnectedModal/useConnectedModal';

import { onUnlockThisFeature } from 'redux/modules/mixpanel';
import { replaceModal } from 'redux/modules/modal';

import DurationLimitModalContents from './DurationLimitModalContents';

const DurationLimitModalContentsContainer: React.FunctionComponent = () => {
  const dispatch = useDispatch();

  const { params } = useConnectedModal('DurationLimitModal');

  const handleIncreaseDurationLimit = React.useCallback(() => {
    dispatch(onUnlockThisFeature(params?.modalSource));
    dispatch(
      replaceModal({
        name: 'AddBillingCycle',
        params: {
          tier: ProductTier.PRO,
          defaultSubscriptionPeriod: 'yearly',
        },
      }),
    );
  }, [dispatch, params]);

  return (
    <DurationLimitModalContents
      onIncreaseDurationLimit={handleIncreaseDurationLimit}
    />
  );
};

export default DurationLimitModalContentsContainer;
